import Confirmation from '@/components/RequestDemo/Confirmation';
import { DemoFormStepTwoFields } from '@/components/RequestDemo/DemoFormStepTwo';
import { HubspotFieldNames } from '@/constants/hubspot';
import { QualifiedExperienceIDs } from '@/constants/qualified';
import { amendQualifiedFormData, handleQualifiedEventListener, saveQualifiedFormData, showQualifiedFormExperience } from '@/lib/qualified';
import { QualifiedFormData } from '@/types/qualified';
import { FC, useEffect, useRef, useState } from 'react';

type QualifiedSchedulerStepProps = {
  formFields: DemoFormStepTwoFields;
  onClose: () => void;
  meetingBookedCallback: (eventData: any) => void;
}

const submitFormData = async (formFields: DemoFormStepTwoFields) => {
  const qualifiedFormData: QualifiedFormData = {
    email: formFields[HubspotFieldNames.Email],
    first_name: formFields[HubspotFieldNames.FirstName],
    last_name: formFields[HubspotFieldNames.LastName],
    company: formFields[HubspotFieldNames.CompanyName],
    title: formFields[HubspotFieldNames.JobTitle] || '',
    phone_number: formFields[HubspotFieldNames.Phone],
    company_size_form: formFields[HubspotFieldNames.CompanySize],
    industry_self_select: formFields[HubspotFieldNames.Industry],
  };
  // Need to await becuase amendQualifiedFormData makes an API call to get ip_country from our API endpoint at /api/geoip
  const amendedFormData = await amendQualifiedFormData(qualifiedFormData);

  // Save form data to Qualified
  saveQualifiedFormData(amendedFormData);
}


const QualifiedSchedulerStep: FC<QualifiedSchedulerStepProps> = ({
  formFields,
  onClose,
  meetingBookedCallback,
}) => {
  // Used to prevent duplicate form submission.  Using ref to avoid re-rendering the component when the form data is saved
  const hasSavedFormData = useRef<boolean>(false);
  const [meetingOffered, setMeetingOffered] = useState<boolean>(false);

  // Submit form data to Qualified and show the qualified scheduler experience
  useEffect(() => {
    const handleQualifiedSchedulerStep = async () => {
      await submitFormData(formFields);
      hasSavedFormData.current = true;
      showQualifiedFormExperience(QualifiedExperienceIDs.TestingForm);
      setMeetingOffered(true);
    }
    // Use hasSavedFormData to prevent duplicate form submission.

    if (!hasSavedFormData.current) {
      handleQualifiedSchedulerStep();
    }
  }, [formFields, hasSavedFormData]);

  // Set up an event listener for meeting booked
  useEffect(() => {
    handleQualifiedEventListener((name, data) => {
      if (name === 'Meeting Booked') {
        meetingBookedCallback(data);
      }
    });
  }, []);

  return (
    <Confirmation userFirstName={formFields[HubspotFieldNames.FirstName]} onClose={onClose} meetingOffered={meetingOffered} />
  );
};

export default QualifiedSchedulerStep;
